import * as types from "../types/printRequests"

const initialState = []

const printRequestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_PRINT_REQUEST:
      return [...state, action.newPrintRequest]
    case types.DELETE_PRINT_REQUEST:
      return state.filter(thermalPrintRequest =>
        thermalPrintRequest.printRequestId !== action.printRequestId
      )
    default: return state
  }
}

export default printRequestsReducer